import React, { useRef } from "react";
import {
  Button,
  ButtonLabel,
  ButtonRight,
  ButtonWithIcon,
  Column,
  GreyOutArea,
  Modal
} from "./CalendarModalStyled";
import GoogleIcon from "components/Icons/GoogleIcon";
import AppleIcon from "components/Icons/AppleIcon";
import OutlookIcon from "components/Icons/OutlookIcon";
import YahooIcon from "components/Icons/YahooIcon";
import { useCalendarModal } from "./hooks";
import helpersClass from "./helpers";
import { event as analyticsEvent } from "analytics";

const category = "calendar_event";
const appleAction = "apple_calendar_button-click";
const googleAction = "google_calendar_button-click";
const outlookAction = "outlook_calendar_button-click";
const yahooAction = "yahoo_calendar_button-click";

const CalendarModal = ({ showModal, toggleModal }) => {
  let { handleDropdownLinkClick, event, t } = useCalendarModal({ toggleModal });
  const helpers = useRef(new helpersClass());

  if (!showModal) {
    return null;
  }
  const addToAppleCalendar = e => {
    analyticsEvent(appleAction, category, appleAction, category);
    handleDropdownLinkClick(e);
  };
  const addToGoogleCalendar = e => {
    analyticsEvent(googleAction, category, googleAction, category);
    handleDropdownLinkClick(e);
  };
  const addToOutlookCalendar = e => {
    analyticsEvent(outlookAction, category, outlookAction, category);
    handleDropdownLinkClick(e);
  };
  const addToYahooCalendar = e => {
    analyticsEvent(yahooAction, category, yahooAction, category);
    handleDropdownLinkClick(e);
  };

  return (
    <>
      <Modal
        id="calendar-modal"
        buttonDirection="COLUMN"
        title={t("add_calendar-title")}
      >
        <Column>
          <Button>
            <ButtonWithIcon
              href={helpers.current.buildUrl(event, "apple")}
              onClick={addToAppleCalendar}
            >
              <AppleIcon />
              <ButtonLabel>{t("add_calendar-apple_button")}</ButtonLabel>
            </ButtonWithIcon>
          </Button>
          <Button>
            <ButtonWithIcon
              href={helpers.current.buildUrl(event, "google")}
              onClick={addToGoogleCalendar}
            >
              <GoogleIcon />
              <ButtonLabel>{t("add_calendar-google_button")}</ButtonLabel>
            </ButtonWithIcon>
          </Button>
          <Button>
            <ButtonWithIcon
              href={helpers.current.buildUrl(event, "outlook")}
              onClick={addToOutlookCalendar}
            >
              <OutlookIcon />
              <ButtonLabel>{t("add_calendar-outlook_button")}</ButtonLabel>
            </ButtonWithIcon>
          </Button>
          <ButtonRight>
            <ButtonWithIcon
              href={helpers.current.buildUrl(event, "yahoo")}
              onClick={addToYahooCalendar}
            >
              <YahooIcon />
              <ButtonLabel>{t("add_calendar-yahoo_button")}</ButtonLabel>
            </ButtonWithIcon>
          </ButtonRight>
        </Column>
      </Modal>
      <GreyOutArea />
    </>
  );
};

export default CalendarModal;
